import sidebars from './sidebars';
import popups from './popups';
import markers from './markers';

export default {
  state: {
    ...sidebars.state,
    ...popups.state,
    ...markers.state,
    lang: localStorage.lang ? localStorage.lang : 'de',
    newMark: null,
  },
  getters: {
    ...sidebars.getters,
    ...popups.getters,
    ...markers.getters,
  },
  mutations: {
    ...sidebars.mutations,
    ...popups.mutations,
    ...markers.mutations,
    setEditorLang(state, payload) {
      state.lang = payload;
    },
    changeLang(state, payload) {
      state.lang = state.lang === 'en' ? 'de' : 'en';
    },
  },
};
